export enum LoginPage {
  LOGIN,
  EMAILLOGIN,
  SIGNUP,
  EMAILSIGNUP,
  SIGNUPHINT,
}
